import React, { useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { allFeatured, getFeatured } from '../reducers/catalog';
import Product from "./Product";
import { getSubsite } from '../reducers/auth';
import Container from 'react-bootstrap/Container';
import SubsiteService from "../services/subsite.service";

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const Featured = () => {
  const dispatch = useDispatch();
  const featured = useSelector(allFeatured);
  const featuredStatus = useSelector(state => state.catalog.featuredStatus);
  const currentSubsite = useSelector(getSubsite);
  const [featuredContent, setFeaturedContent]  = useState(<Spinner text="Loading..." />);

  const [content, setContent] = useState('');

  useEffect(() => {
    async function fetchData() {
      var content = await SubsiteService.getHomepageContent();
      console.log("CONTENT", content);
      setContent(content.homepage);
      //var shipping = await ShippingService.getShipping();
      //console.log("SHIPPING", shipping);
    }
    fetchData();   
  }, []);

  useEffect(() => {
    console.log("Get FEATURED");
    if (featuredStatus === 'idle') {
      dispatch(getFeatured());
    } else if (featuredStatus === 'succeeded') {
      console.log("FEATUREDDD", featured);
      setFeaturedContent(featured.map(featuredItem => (
          <Product product={featuredItem} featured/>
      )));
    } else if (featuredStatus === 'failed') {
      setFeaturedContent(<div>error</div>);
    }
  }, [featuredStatus, dispatch]);

  console.log("AFTER Content");

  return (
    <Container>
        <div style={{padding: 30}}>
        {(!content || content == "" || content == "<p><br></p>") && <h3>Welcome to {currentSubsite.subsiteName} Apparel Site</h3>}
        {content && <div dangerouslySetInnerHTML={{ __html: content }}></div>}

      <h3>Featured Items</h3>
      <div class="product-container">
            { featuredContent }
      </div>
      </div>
    </Container>
  );
};
export default Featured;